import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { LeadSourceRow } from "./LeadSourceRow";
import { NewLeadSourceDialog } from "./NewLeadSourceDialog";
import { LeadStats } from "./LeadStats";
import { PlatformConnect } from "./PlatformConnect";

// Lead sources: external site forms / webhooks (real) and ad platforms (SIMULATED: no real account is ever connected).
export default function CrmLeadSources({ tid }) {
  const api = useApi();
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const [fresh, setFresh] = useState(null);
  const load = useCallback(() => api.get(`/t/${tid}/lead-sources`).then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e))), [api, tid]);
  useEffect(() => { load(); }, [load]);
  if (!d) return <Loader2 className="animate-spin text-slate-400" />;
  const created = (src) => { setFresh(src); setOpen(false); load(); };
  return (
    <div className="space-y-3" data-testid="crm-lead-sources">
      <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="lead-sources-sim-note">
        Facebook, Instagram e TikTok si collegano dal riquadro <b>«Piattaforme pubblicitarie»</b>: è «reale» solo dopo il primo lead da un account vero. Le fonti «Simulazione» e i collegamenti «Prova DEV» producono solo lead di prova. Google Ads, sito esterno, WordPress (CF7, Elementor, WPForms), widget e API ricevono lead veri; Google Ads è «reale» solo dopo il primo lead da una campagna vera.</p>
      <PlatformConnect tid={tid} onChanged={load} />
      {d.can_manage ? <Button className="h-10" onClick={() => setOpen(true)} data-testid="lead-source-new"><Plus size={15} className="mr-1.5" />Collega una fonte</Button>
        : <p className="text-xs text-slate-500" data-testid="lead-sources-readonly">Il tuo ruolo può vedere le fonti, non collegarle.</p>}
      {d.sources.length === 0 && <p className="text-sm text-slate-500" data-testid="lead-sources-empty">Nessuna fonte collegata.</p>}
      {d.sources.map((s) => <LeadSourceRow key={s.id} tid={tid} src={s} catalog={d.catalog} canManage={d.can_manage} freshKey={fresh?.id === s.id ? fresh.key : null} onChange={load} />)}
      <NewLeadSourceDialog open={open} onOpenChange={setOpen} tid={tid} catalog={d.catalog} onCreated={created} />
      <LeadStats tid={tid} tick={d} />
    </div>);
}
